"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecommendationStepper = void 0;
var _reactRedux = require("react-redux");
var _recommendationActions = require("../../store/recommendation/recommendationActions");
var _recommendationSelectors = require("../../store/recommendation/recommendationSelectors");
var useRecommendationStepper = function useRecommendationStepper() {
  var steps = (0, _reactRedux.useSelector)(_recommendationSelectors.selectRecommendationsSteps);
  var currentStep = (0, _reactRedux.useSelector)(_recommendationSelectors.selectRecommendationCurrentStep);
  var dispatch = (0, _reactRedux.useDispatch)();
  var onNextStepper = function onNextStepper() {
    dispatch((0, _recommendationActions.goToNextStep)());
  };
  var onBackStepper = function onBackStepper() {
    dispatch((0, _recommendationActions.goToPreviousStep)());
  };
  var isLastStep = currentStep === steps.length;
  var isFirstStep = currentStep === 1;
  var currentStepObject = steps[currentStep - 1];
  return {
    steps: steps,
    currentStep: currentStep,
    onNextStepper: onNextStepper,
    onBackStepper: onBackStepper,
    isLastStep: isLastStep,
    isFirstStep: isFirstStep,
    currentStepObject: currentStepObject
  };
};
exports.useRecommendationStepper = useRecommendationStepper;